import React from 'react';

const CollectionSchema = ({ hits, collection, totalResultsCount }) => {
  const COL_SCHEMA = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'OfferCatalog',
    '@id': document.querySelector("link[rel='canonical']").getAttribute('href'),
    name: collection.title,
    url: document.querySelector("link[rel='canonical']").getAttribute('href'),
    numberOfItems: totalResultsCount,
  });
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: COL_SCHEMA }}></script>;
};

export default CollectionSchema;
